import React from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { RaisedButton, MenuItem, SelectField } from "material-ui";
import {
  BuscarArancelGESPP,
} from "../FiltroBusquedaArancelGES/actions";


class TablePaginationCustomAG extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      page: 1,
      rowsPerPage: 10,
    };
  }

  componentWillMount() {
    if (this.props.pageDefault && this.props.pageDefault > 0) {
      this.setState({ page: this.props.pageDefault });
    }
    if (this.props.rowsPerPageDefault && this.props.rowsPerPageDefault > 0) {
      this.setState({ rowsPerPage: this.props.rowsPerPageDefault });
    }
    this.SetPaginacion(this.props.pageDefault, this.props.rowsPerPageDefault);
  }

  componentDidMount() {
    const page = this.props.pageDefault && this.props.pageDefault > 1 ?
      this.props.pageDefault : this.state.page;
    this.SetPaginacion(page, this.state.rowsPerPage);
  }

  SetFilasPorPagina = (event, index, value) => {
    const rowsPage = value;
    this.setState({ rowsPerPage: rowsPage });
    this.SetPaginacion(1, rowsPage);
  }

  SetPaginacion = (pagenew, rowsPerPage) => {
    const idTableBodyc = this.props.idTableBody;
    const itemDesde = rowsPerPage * (pagenew - 1);
    const cantidad = rowsPerPage;
    const total = this.props.totalRows;

    if (document.getElementById(idTableBodyc)) {
      const tableBodyRows = document.getElementById(idTableBodyc).querySelectorAll("tbody>tr");
      for (let i = 0; i < total; i += 1) {
        let styleDisplay = "";
        if (i < itemDesde || i > (itemDesde + cantidad) - 1) {
          styleDisplay = "none";
        }
        if (tableBodyRows[i]) {
          tableBodyRows[i].style.display = styleDisplay;
        }
      }
      this.setState({ page: pagenew });
    }
  }

  BuscarPrestacionesPP = (valor, totalPagina) => {
    this.props.dispatch(BuscarArancelGESPP(valor, totalPagina));
  }

  render() {
    const cantPages = this.props.totalRows % this.state.rowsPerPage === 0 ?
      parseInt(this.props.totalRows / this.state.rowsPerPage, 0) :
      parseInt(this.props.totalRows / this.state.rowsPerPage, 0) + 1;

    const itemsNumPages = [];
    let isInvisible = false;
    for (let i = 1; i <= cantPages; i += 1) {
      if ((cantPages - i > 3 || i > 3) &&
        i !== this.state.page && Math.abs(this.state.page - i) > 1 &&
        i > 2 && i < cantPages - 1) {
        if (!isInvisible) {
          itemsNumPages.push((
            <div key={`inviblebtn${i}`} style={{ width: 30, display: "inline-block" }}>.....</div>
          ));
        }
        isInvisible = true;
      } else {
        isInvisible = false;
        itemsNumPages.push((
          <RaisedButton
            key={`btn_pagination_${this.props.idTableBody}_${i}`}
            label={i}
            secondary
            labelStyle={this.props.labelStyleBtnPage}
            overlayStyle={this.props.overlayStyleBtnPage}
            rippleStyle={this.props.rippleStyleBtnPage}
            buttonStyle={this.props.buttonStyleBtnPage}
            style={this.props.styleBtnPage}
            disabled={i === this.state.page}
            onClick={() => { this.BuscarPrestacionesPP(i, 5); this.SetPaginacion(i); }}

          />
        ));
      }
    }

    return (
      <div>
        {this.props.totalRows === 0 ?
          null :
          <div
            style={{ textAlign: "center", margin: "10px 0px" }}
          >
            {itemsNumPages}
            {this.props.showRowsPerPage || false ?
              <div style={{ float: "right" }}>
                <div className="row">
                  <div className="col-4">
                    <span>filas por página:</span>
                  </div>
                  <div className="col-4">
                    <SelectField
                      name={`dd_pagination_${this.props.idTableBody}`}
                      id={`dd_pagination_${this.props.idTableBody}`}
                      value={this.state.rowsPerPage}
                      onChange={this.SetFilasPorPagina}
                      labelStyle={this.props.labelStyleRowsPerPage}
                      underlineStyle={this.props.underlineStyleRowsPerPage}
                      iconStyle={this.props.iconStyleRowsPerPage}
                      menuItemStyle={this.props.menuItemStyleRowsPerPage}
                      selectedMenuItemStyle={this.props.selectedMenuItemStyleRowsPerPage}
                      style={this.props.styleRowsPerPage}
                    >
                      <MenuItem value={5} primaryText="5" />
                      <MenuItem value={10} primaryText="10" />
                      <MenuItem value={15} primaryText="15" />
                      <MenuItem value={20} primaryText="20" />
                      <MenuItem value={25} primaryText="25" />
                    </SelectField>

                  </div>
                </div>
              </div>
              : null}
          </div>

        }
      </div>
    );
  }
}

TablePaginationCustomAG.defaultProps = {
  pageDefault: 1,
  rowsPerPageDefault: 10,
  showRowsPerPage: true,

  labelStyleBtnPage: null,
  overlayStyleBtnPage: null,
  rippleStyleBtnPage: null,
  styleBtnPage: null,
  buttonStyleBtnPage: null,

  styleRowsPerPage: null,
  labelStyleRowsPerPage: null,
  underlineStyleRowsPerPage: null,
  iconStyleRowsPerPage: null,
  menuItemStyleRowsPerPage: null,
  selectedMenuItemStyleRowsPerPage: null,
};

TablePaginationCustomAG.propTypes = {
  totalRows: PropTypes.number.isRequired,
  pageDefault: PropTypes.number,
  rowsPerPageDefault: PropTypes.number,
  idTableBody: PropTypes.string.isRequired,
  showRowsPerPage: PropTypes.bool,

  labelStyleBtnPage: PropTypes.any,
  overlayStyleBtnPage: PropTypes.any,
  rippleStyleBtnPage: PropTypes.any,
  styleBtnPage: PropTypes.any,
  buttonStyleBtnPage: PropTypes.any,

  styleRowsPerPage: PropTypes.any,
  labelStyleRowsPerPage: PropTypes.any,
  underlineStyleRowsPerPage: PropTypes.any,
  iconStyleRowsPerPage: PropTypes.any,
  menuItemStyleRowsPerPage: PropTypes.any,
  selectedMenuItemStyleRowsPerPage: PropTypes.any,
};

const mapDispatchToProps = (dispatch) => ({
  dispatch: (action) => { dispatch(action); },
});
//export default ;
export default connect(null, mapDispatchToProps)(TablePaginationCustomAG);




// WEBPACK FOOTER //
// ./src/components/ArancelGES/TablePagination/view.jsx